import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Grid, Button } from '@material-ui/core';
import { Search, Filter } from './components';
import FilterListIcon from '@material-ui/icons/FilterList';
import { useDispatch, useSelector } from 'react-redux';
import { ChargeStartDateChange, ChargeEndDateChange, GetCharge, GetMockCharge } from 'store/actions';
import { DatePicker } from '@material-ui/pickers';

const SearchBar = props => {
  const { onFilter, searchValue, onSearch, className, ...rest } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const maxDate = useSelector(({ charge }) => charge.maxDate);
  const minDate = useSelector(({ charge }) => charge.minDate);
  const startDate = useSelector(({ charge }) => charge.startDate);
  const endDate = useSelector(({ charge }) => charge.endDate);

  const [openFilter, setOpenFilter] = useState(false);
  const [openStartDateCalendar, setOpenStartDateCalendar] = useState(false);
  const [openEndDateCalendar, setOpenEndDateCalendar] = useState(false);

  const handleFilterOpen = () => {
    setOpenFilter(true);
  };

  const handleFilterClose = () => {
    dispatch(GetCharge());
    // dispatch(GetMockCharge());
    setOpenFilter(false);
  };

  const handleCalendarOpen = type => {
    if (type === 'start') {
      setOpenStartDateCalendar(true);
    } else {
      setOpenEndDateCalendar(true);
    }
  };

  const handleCalendarClose = type => {
    if (type === 'start') {
      setOpenStartDateCalendar(false);
    } else {
      setOpenEndDateCalendar(false);
    }
  };

  const handleCalendarChange = (date, type) => {
    if (type === 'start') {
      dispatch(ChargeStartDateChange(date));
    } else {
      dispatch(ChargeEndDateChange(date));
    }
  };

  return (
    <Grid
      {...rest}
      className={clsx(classes.root, className)}
      container
      spacing={3}
    >
      <Grid item>
        <Search
          className={classes.search}
          onSearch={onSearch}
          searchValue={searchValue}
        />
      </Grid>
      <Grid item>
        <Button
          className={classes.filterButton}
          color="primary"
          onClick={handleFilterOpen}
          size="small"
          variant="outlined"
        >
          <FilterListIcon className={classes.filterIcon} /> Show filters
        </Button>
      </Grid>
      <Filter
        onClose={handleFilterClose}
        openCalendar={handleCalendarOpen}
        openFilter={openFilter}
      />

      <DatePicker
        autoOk
        id="startDate"
        maxDate={endDate}
        minDate={minDate}
        onChange={e => handleCalendarChange(e, 'start')}
        onClose={() => handleCalendarClose('start')}
        open={openStartDateCalendar}
        style={{ display: 'none' }}
        value={startDate}
        variant="dialog"
      />

      <DatePicker
        autoOk
        id="endDate"
        maxDate={maxDate}
        minDate={startDate}
        onChange={e => handleCalendarChange(e, 'end')}
        onClose={() => handleCalendarClose('end')}
        open={openEndDateCalendar}
        style={{ display: 'none' }}
        value={endDate}
        variant="dialog"
      />
    </Grid>
  );
};

SearchBar.propTypes = {
  className: PropTypes.string,
  onSearch: PropTypes.func,
  searchValue: PropTypes.string
};

export default SearchBar;

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap'
  },
  search: {
    flexGrow: 1,
    maxWidth: 480,
    flexBasis: 480
  },
  filterButton: {
    marginLeft: 'auto'
  },
  filterIcon: {
    marginRight: theme.spacing(1)
  }
}));
